<div class="loader absolute" *ngIf="isLoading">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
  </svg>
</div>
<div class="modal-container" *ngIf="!isLoading">
  <div class="close"><i class="material-icons" (click)="closeModal()">close</i></div>
  <!--  New Feature Description -->
  <ng-container *ngIf="(!isNext && showingNewFeatureWithPlan) || showingOnlyNewFeature">
    <new-feature-notification [feature]="relatedFeature" (onClose)="closeModal()"></new-feature-notification>
  </ng-container>
  <!--  Dealer Plan Description-->
  <ng-container *ngIf="(isNext && showingNewFeatureWithPlan) || showingOnlyPlan">
    <div class="title-area">
      <div class="title">Upgrade today for access to new features</div>
      <div class="description">CHeKT is excited to announce a series of new feature releases that will expand the capabilities of the CHeKT Visual Security platform and our service offerings.</div>
    </div>
    <!--  Plan-->
    <ng-container *ngIf="me().type === 2">
      <reseller-plan-description (onUpdate)="onClickShowChangingPlanModal($event)" (onClose)="closeModal()"></reseller-plan-description>
    </ng-container>
    <ng-container *ngIf="me().type != 2">
      <dealer-plan-description (onUpdate)="onClickShowChangingPlanModal($event)" (onClose)="closeModal()"></dealer-plan-description>
    </ng-container>
  </ng-container>
  <!--  Action Part-->
  <div class="modal-action" *ngIf="showingNewFeatureWithPlan">
    <mat-checkbox *ngIf="!isNext && modal.data['feature'] === 'root'" style="color:hsla(0,0%,0%,0.87);" [(ngModel)]="isHiding" [labelPosition]="'after'">Don"t Show Again</mat-checkbox>
    <button class="secondary-button" (click)="onCancelOrBack()">{{isNext || currentIdx > 1 ? "Back" :"Close"}}</button>
    <button class="primary-button" (click)="nextModal()">{{isNext ? "Done" : "Next for More Details"}}</button>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>